import { InfoCircleFilled } from '@creditornot/cb-icons';
import { typographyCss } from '@creditornot/cb-ingredients';
import { DateTime } from 'luxon';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Root = styled.div`
  display: inline-flex;
  align-items: flex-start;
  margin-block-start: 24px;
  gap: 6px;
  max-width: 280px;
  ${typographyCss.Small}
`;

const InfoIcon = styled(InfoCircleFilled).attrs({
  width: 12,
  height: 12,
})`
  flex-shrink: 0;
  margin-block-start: 2px;
`;

export const TimeZoneNote = () => {
  const localDate = DateTime.local();
  const timeZone = `${localDate.zoneName} (${localDate.offsetNameShort})`;
  return (
    <Root>
      <InfoIcon />
      <FormattedMessage id="shared-menu.dates.timezone-note" values={{ timeZone }} />
    </Root>
  );
};
